var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 147,
    viewBox: "0 0 138 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 139.764C7.68569 91.7654 20.8322 66.1562 63.7497 43.9026C80.0769 35.4367 98.1022 32.7591 115.898 29.5235C126.501 27.5957 124.133 22.5656 113.981 19.7456C102.506 16.5582 91.5631 12.245 80.2378 9.0092C66.1042 4.971 109.641 8.19361 124.334 8.62576C145.121 9.23715 113.981 68.0793 113.981 81.0967",
    stroke: "white",
    strokeWidth: 13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitearrow);
export default __webpack_public_path__ + "static/media/whitearrow.6d21191dfdb13be43d1ddb2df0ffe823.svg";
export { ForwardRef as ReactComponent };